import { KeyFiller } from "./KeyFiller";

export enum EventsEnum{
    showBackground = "",
}

export namespace EngineEvents {
    export const musicLoudness = "musicLoudness";
}